import { Loader2, SearchX } from "lucide-react";

type AutocompleteEmptyStateProps = {
  isLoading: boolean
  hasQuery: boolean
  isQueryValid: boolean
};

export const AutocompleteEmptyState = ({
  isLoading,
  hasQuery,
  isQueryValid,
}: AutocompleteEmptyStateProps) => {
  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center gap-3 py-8 text-gray-500 dark:text-gray-400">
        <Loader2 className="size-8 animate-spin text-primary-500" />
        <p className="text-sm font-medium">Recherche en cours...</p>
      </div>
    );
  }

  if (!isQueryValid && hasQuery) {
    return (
      <div className="flex flex-col items-center justify-center gap-3 py-8 text-gray-500 dark:text-gray-400">
        <SearchX className="size-8 opacity-50" />
        <p className="text-sm font-medium">Tapez au moins 2 caractères</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center gap-3 py-8 text-gray-500 dark:text-gray-400">
      <SearchX className="size-8 opacity-50" />
      <div className="text-center">
        <p className="text-sm font-medium">Aucun résultat trouvé</p>
        <p className="mt-1 text-xs opacity-75">Essayez un autre terme de recherche</p>
      </div>
    </div>
  );
};
